import React, { useEffect } from 'react';
import styled from 'styled-components/macro';

import {
  ICustomer,
  loadCustomers,
  selectDownloadCustomers,
} from 'redux/reducers/customers';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';

export const StyledIcon = styled.svg`
  width: 2rem;
  min-width: 2rem;
  height: 2rem;

  image {
    width: 100%;
    height: 100%;
  }
`;

export const SmallStyledIcon = styled.svg`
  width: 1.5rem;
  min-width: 1.5rem;
  height: 1.5rem;
  margin-left: -0.3rem;

  image {
    width: 100%;
    height: 100%;
  }
`;

interface ICustomerIconProps {
  customer: string;
  showHiddenPlaceholder?: boolean;
  small?: boolean;
  isDownloadsDsp?: boolean;
}

const CustomerIcon: React.FC<ICustomerIconProps> = (props) => {
  const { customer, showHiddenPlaceholder, small, isDownloadsDsp } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadCustomers());
  }, [dispatch]);

  const customerList: any = useSelector(
    isDownloadsDsp
      ? selectDownloadCustomers
      : (state: RootState): any => state.customers.data
  );

  const customerElement = customerList.find(
    (d: ICustomer) =>
      d.name.toLowerCase() === customer.toLowerCase() ||
      d.displayName.toLowerCase() === customer.toLowerCase() ||
      (customer === 'itunes' &&
        d.name === 'apple' &&
        d.feedType === 'downloads')
  );

  if (!customerElement && showHiddenPlaceholder) return <StyledIcon as="div" />;
  if (!customerElement) return null;

  return small ? (
    <SmallStyledIcon>
      <image href={customerElement.vectorImageUrl} />
    </SmallStyledIcon>
  ) : (
    <StyledIcon>
      <image href={customerElement.vectorImageUrl} />
    </StyledIcon>
  );
};

export default CustomerIcon;
